import React from 'react';
import MDEditor from '@uiw/react-md-editor';

// Read-only markdown in the app's dark theme. Uses the same renderer as the editor preview,
// so what users see here matches what they wrote.
const MarkdownView = ({ source, compact = false, className = '' }) => (
  <div data-color-mode="dark" className={`text-left ${className}`}>
    <MDEditor.Markdown
      source={source || ''}
      style={{ backgroundColor: 'transparent', fontSize: compact ? 14 : 16 }}
    />
  </div>
);

export default MarkdownView;
